export const getResponseStatus = (error: unknown) =>
  typeof error === 'object' && error
    ? 'statusCode' in error && typeof error.statusCode === 'number'
      ? error.statusCode
      : 'response' in error &&
          typeof error.response === 'object' &&
          error.response &&
          'status' in error.response &&
          typeof error.response.status === 'number'
        ? error.response.status
        : undefined
    : undefined;

export const getNpsSubmitErrorMessage = (error: unknown) => {
  const status = getResponseStatus(error);

  if (status === 409) {
    return 'Você já respondeu esta campanha. Obrigado pela sua participação.';
  }

  if (status === 410) {
    return 'Esta campanha foi encerrada e não está mais recebendo respostas.';
  }

  if (status === 400 || status === 422) {
    return 'Não foi possível enviar com os horários selecionados. Revise as seleções e tente novamente.';
  }

  if (status && status >= 500) {
    return 'O servidor não conseguiu processar sua resposta agora. Tente novamente em instantes.';
  }

  return 'Não foi possível enviar sua resposta. Verifique sua conexão e tente novamente.';
};
